// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatFeedbackComment-modulecomment__DMfqG";
var _2 = "GretaAIChatFeedbackComment-modulecommentField__YF2Md";
export { _1 as "comment", _2 as "commentField" }
